// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { Auth } from 'aws-amplify';
import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { isEmail, isValidPassword, doesUsernameHaveLessThan30 } from '../../../lib/validation';
import TextBoxInput from '../../../components/TextBoxInput';
import PasswordInput from '../../../components/PasswordInput';
import { useIntl } from 'react-intl';
import S from './styles';
import LoginPopSubmit from '../../LoginPage/components/LoginPopSubmit';
import { BIFROST_URL } from '../../../configuration';
import { checkLoginMethod } from '../../../apis/member';

const RegisterForm = (): JSX.Element => {
  const history = useHistory();
  const intl = useIntl();
  const [clickSubmit, setClickSubmit] = useState(false);
  const gotoBirfrost = async () => {
    window.location.href = BIFROST_URL;
  }

  return (
    <Formik
      initialValues={{
        email: '',
        password: '',
        username: ''
      }}
      validate={(values) => {
        const errors: { email?: string, password?: string, username?:string } = {};
        if (!values.email) {
          errors.email = 'J022';
        } else if (!isEmail(values.email.trim())) {
          errors.email = 'J026';
        }
        if (!values.username) {
          errors.username = 'J021';
        } else if (!doesUsernameHaveLessThan30(values.username.trim())) {
          errors.username = 'J024';
        }
        //else if (!isUsernameValid(values.username.trim())) {
        //   errors.username = '*使用者名稱不可為數字或標點符號';
        // }
        if (!values.password) {
          errors.password = 'J023';
        } else if (!isValidPassword(values.password)) {
          errors.password = 'J028';
        }
        return errors;
      }}
      onSubmit={async (
        { email, password, username },
        { setSubmitting, setErrors }
      ) => {
        email = email.trim().toLowerCase();
        if (email.includes('ecloudvalley.com')) {
          const loginMethod = await checkLoginMethod(email);
          if (loginMethod.data) {
            setClickSubmit(true);
            setSubmitting(false);
            return;
          }
        }
        Auth.signUp({
          username: email,
          password,
          attributes: {
            name: username,
            locale: intl.locale.toLowerCase(),
          }
        })
          .then((data) => {
            console.log({ data })
            history.push(`/gotoemail?email=${email}`);
          })
          .catch((error) => {
            if (error.code === 'UsernameExistsException') {
              setErrors({ email: 'J027' });
            } else {
              history.push('/register?status=failed')
            }
            console.log({ error });
          })
          .finally(() => {
            setSubmitting(false);
          });
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        isSubmitting
      }) => {
        const intl = useIntl();
        const usernameError = errors.username ? '*' + intl.formatMessage({ id: errors.username }) : undefined;
        const emailError = errors.email ? '*' + intl.formatMessage({ id: errors.email }) : undefined;
        const passwordError = errors.password ? '*' + intl.formatMessage({ id: errors.password }) : undefined;

        return (
          <S.Container as={Form}>
            <S.TopWrapper>
              <TextBoxInput
                textBoxName={intl.formatMessage({ id: 'J014' })}
                placeholder={intl.formatMessage({ id: 'J014' })}
                name="username"
                value={values.username}
                error={usernameError}
                touched={touched.username}
                onChange={handleChange}
                onBlur={handleBlur}
                autoComplete="new-password"
              />
              <TextBoxInput
                textBoxName={intl.formatMessage({ id: 'J015' })}
                placeholder={intl.formatMessage({ id: 'J015' })}
                name="email"
                value={values.email}
                error={emailError}
                touched={touched.email}
                onChange={handleChange}
                onBlur={handleBlur}
                autoComplete="new-password"
              />
              <S.PasswordWrapper>
                <PasswordInput
                  name="password"
                  label={intl.formatMessage({ id: 'J016' })}
                  placeholder={intl.formatMessage({ id: 'J016' })}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                  error={passwordError}
                  touched={touched.password}
                  autoComplete="new-password" />
                {!values.password && !touched.password && <S.NotePasswordRule>{intl.formatMessage({ id: 'J017' })}</S.NotePasswordRule>}
              </S.PasswordWrapper>
            </S.TopWrapper>
            <S.BottomWrapper>
              <S.GoToLoginPageWrapper>
                <S.GoToLoginPage to={'/login'}>{intl.formatMessage({ id: 'J018' })}</S.GoToLoginPage>
              </S.GoToLoginPageWrapper>
              <S.Button
                type="submit"
                disabled={isSubmitting || Object.keys(errors).length > 0}
              >{intl.formatMessage({ id: 'J019' })}</S.Button>
            </S.BottomWrapper>
            { clickSubmit ? <LoginPopSubmit setClickSubmit={setClickSubmit} gotoBirfrost={gotoBirfrost} messageId={'J067'}></LoginPopSubmit> : null}
          </S.Container>
        )
      }}
    </Formik>
  );
}

export { RegisterForm as default }
